




















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState, mapMutations } from 'vuex';
import { ComponentModel, ResponsiveSizes } from '@/models';
import TreeView from '@/components/TreeView.vue';
import PropertiesView from '@/components/properties-css/PropertiesView.vue';
import DefaultComponent from '@/components/custom/DefaultComponent.vue';
import CheckComponent from '@/components/custom/CheckComponent.vue';
import InputComponent from '@/components/custom/InputComponent.vue';
import SelectComponent from '@/components/custom/SelectComponent.vue';
import TextareaComponent from '@/components/custom/TextareaComponent.vue';

Vue.component('TreeView', TreeView);
Vue.component('PropertiesView', PropertiesView);
Vue.component('DefaultComponent', DefaultComponent);
Vue.component('CheckComponent', CheckComponent);
Vue.component('InputComponent', InputComponent);
Vue.component('SelectComponent', SelectComponent);
Vue.component('TextareaComponent', TextareaComponent);

@Component({
  computed: {
    ...mapState(['root', 'selected', 'responsiveSize'])
  },
  methods: {
    ...mapMutations([
      'addGrid',
      'addColumn',
      'addLabel',
      'addSpan',
      'addInput',
      'addTextarea',
      'addSelect',
      'addOption',
      'addCheck',
      'addButton',
      'addAnchor',
      'addTable',
      'addTableRow',
      'addHeaderCell',
      'addDataCell',
      'copySelected',
      'cutSelected',
      'pasteToSelected',
      'moveUp',
      'moveDown',
      'deleteSelected',
      'clearState',
      'loadState'
    ])
  }
})
export default class Designer extends Vue {
  root!: ComponentModel;
  selected!: ComponentModel;
  responsiveSize!: ResponsiveSizes;
  htmlCode: string;
  maxWidth: number;

  constructor() {
    super();
    this.htmlCode = '';
    this.maxWidth = 768;
  }

  setSize(responsiveSize: ResponsiveSizes) {
    this.$store.commit('setResponsiveSize', responsiveSize);
    this.adjustSizes();
  }

  @Watch('responsiveSize')
  responsiveSizeChange() {
    this.adjustSizes();
  }

  saveState() {
    this.$store.commit('saveState');
    this.$store.commit('savePreview');
  }

  preview() {
    this.$store.commit('savePreview');
    const routeData = this.$router.resolve({ name: 'preview' });
    window.open(routeData.href, '_blank');
  }

  copyHtmlCode() {
    this.$store.commit('savePreview');
    const el = document.createElement('textarea');
    el.value = window.localStorage.getItem('form-preview')!;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }

  mounted() {
    if (this.$route.query['s']) {
      if (this.$route.query['s'] === 'example1')
        this.$store.commit('loadExample1');
      else if (this.$route.query['s'] === 'example2')
        this.$store.commit('loadExample2');
      this.$router.replace('/');
    } else this.$store.commit('loadState');

    window.onresize = this.adjustSizes;
    this.adjustSizes();
  }

  getResponsiveSizePixels() {
    switch (this.responsiveSize) {
      case ResponsiveSizes.All:
      case ResponsiveSizes.Small:
        return 640;
      case ResponsiveSizes.Medium:
        return 768;
      case ResponsiveSizes.Large:
        return 1024;
        break;
    }
  }

  adjustSizes() {
    const screenwidth = document.documentElement.clientWidth;
    const width = this.getResponsiveSizePixels();

    (this.$refs.compsLayout as HTMLElement).style.width = `${
      screenwidth < width ? screenwidth : width
    }px`;
    if (screenwidth < 768) {
      (this.$refs.compsContainer as HTMLElement).style.width = `auto`;
    } else if (screenwidth < 1024) {
      (this.$refs.propsContainer as HTMLElement).style.maxHeight = '16rem';
      (this.$refs.compsContainer as HTMLElement).style.maxHeight = 'auto';
      (this.$refs.compsContainer as HTMLElement).style.width = `${screenwidth -
        80}px`;
    } else {
      const maxHeight = document.documentElement.clientHeight;
      (this.$refs
        .propsContainer as HTMLElement).style.maxHeight = `${maxHeight -
        256 -
        93}px`;
      (this.$refs
        .compsContainer as HTMLElement).style.maxHeight = `${maxHeight -
        120}px`;
      (this.$refs.compsContainer as HTMLElement).style.width = `${screenwidth -
        404}px`;
    }
  }
}
